var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vt-date-picker',{ref:"datePicker",attrs:{"lang":"es","model":_vm.model,"not-after":_vm.notAfter},on:{"update":function($event){_vm.model = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }